import { UiKitTagBase } from '@/fo/ui/kit/tag/base';
import { UiKitTagGroup } from '@/fo/ui/kit/tag/group';

import { FilterOption } from '../../types';

import { styles } from './FilterPanel.styles';

export interface FilterPanelProps {
  filters: FilterOption[];
  selectedFilters: string[];
  onFilterChange?: (value: string[]) => void;
  rootRef?: React.RefObject<HTMLDivElement | null>;
  className?: string;
}

export function FilterPanel({
  filters,
  selectedFilters,
  onFilterChange,
  rootRef,
  className
}: FilterPanelProps) {
  const slots = styles();

  const handleFilterChange = (value: string[]) => {
    onFilterChange?.(value);
  };

  return (
    <div
      className={slots.base({ className })}
      ref={rootRef}
    >
      <UiKitTagGroup
        selectionMode="multiple"
        onSelectionChange={handleFilterChange}
        value={selectedFilters}
      >
        {filters
          .filter((filter) => selectedFilters.includes(filter.value))
          .map((filter) => (
            <UiKitTagBase
              className={slots.tag()}
              key={filter.value}
              value={filter.value}
            >
              {filter.label}
            </UiKitTagBase>
          ))}
        {filters
          .filter((filter) => !selectedFilters.includes(filter.value))
          .map((filter) => (
            <UiKitTagBase
              className={slots.tag()}
              key={filter.value}
              value={filter.value}
            >
              {filter.label}
            </UiKitTagBase>
          ))}
      </UiKitTagGroup>
    </div>
  );
}
